import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIMultiColumn from 'UIComponents/layout/UIMultiColumn';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getCopy = actionTypeBodyInfoKey => {
  switch (actionTypeBodyInfoKey) {
    case 'scheduleUnpublish':
      return {
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.buttons.scheduleUnpublish"
        }),
        nothingScheduledText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.nothingScheduled.scheduleUnpublish"
        })
      };
    case 'scheduleUpdate':
      return {
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.buttons.scheduleUpdate"
        }),
        nothingScheduledText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.nothingScheduled.scheduleUpdate"
        })
      };
    default:
      return {
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.buttons.schedulePublish"
        }),
        nothingScheduledText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.nothingScheduled.schedulePublish"
        })
      };
  }
};
const NothingScheduledControls = ({
  actionTypeBodyInfoKey,
  onScheduleClick
}) => {
  const {
    buttonText,
    nothingScheduledText
  } = getCopy(actionTypeBodyInfoKey);
  return /*#__PURE__*/_jsx(UIMultiColumn, {
    flush: true,
    children: /*#__PURE__*/_jsxs(UIMultiColumnGroup, {
      children: [/*#__PURE__*/_jsx(UIMultiColumnItem, {
        horizontalAlign: "left",
        verticalAlign: "middle",
        className: "p-x-2",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary",
          onClick: onScheduleClick,
          "data-test-id": "schedule",
          children: buttonText
        })
      }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
        horizontalAlign: "left",
        verticalAlign: "middle",
        className: "p-x-2",
        children: nothingScheduledText
      })]
    })
  });
};
export default NothingScheduledControls;